import Particle from "./Particle";
import AbstractParticles from "./AbstractParticles";

class CenterParticles extends AbstractParticles {
  // ---------------------------------------------------------------------------
  // --	CenterParticles
  // ---------------------------------------------------------------------------

  constructor() {
    super(".js-bg-center-marker");

    //インデックス
    this.index = -1;

    //黄色いパーティクル
    this.particle = new Particle();
    this.particle.randomMove(100, 300);
    this.container.addChild(this.particle);

    //白いパーティクル
    this.wh = new Particle(true);
    this.wh.randomMove(50, 150);
    this.container.addChild(this.wh);
  }

  setPlate(plate) {
    this.plate = plate;
  }

  onProgress(progress) {
    super.onProgress(progress);

    //パーティクルをセンターに
    if (progress.index >= 4 && this.index < 4) {
      this.particle.randomMove(0, 0);
      this.wh.randomMove(0, 0);
    }
    //パーティクルをランダムに
    else if (progress.index <= 3 && this.index >= 4) {
      this.particle.randomMove(100, 300);
      this.wh.randomMove(50, 150);
    }

    //白パーティクルの表示切り替え
    if (progress.index == 4) {
      this.wh.alpha = 1 - 1 * progress.progress;
      this.wh.scale.set(this.wh.alpha, this.wh.alpha);
    } else if (progress.index >= 5) {
      this.plate.alpha = 1;
      this.wh.alpha = 0;
      this.wh.scale.set(0, 0);
    } else {
      this.plate.alpha = 0;
      this.wh.alpha = 1;
      this.wh.scale.set(1, 1);
    }

    //プレートの表示
    if (progress.index == 5) {
      this.plate.alpha = progress.progress;
    } else if (progress.index >= 6) {
      this.plate.alpha = 1;
    } else {
      this.plate.alpha = 0;
    }

    //インデックス更新
    this.index = progress.index;
  }

  // ---------------------------------------------------------------------------
}

export default CenterParticles;
